import React, { useState } from "react";
import "./TextLong.css";

export default function TextToggle(props) {
  const [toggled, setToggled] = useState(false);

  if (!props.textToggleTitle) {
    // check this
    return null;
  }

  // const to = props.text;
  const toggleParagraphs = props.textToggleContent.split("\r\n\r\n");

  const processToggleParagraph = (par) => {
    const splitForTag = par.split("<q>");
    return splitForTag.length > 1 ? splitForTag[1] : splitForTag[0];
  };

  return (
  props.isMobile ? (
    <div
        style={{
            position: "relative",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: "black",
            padding: "0px 25vw 4px 25vw",
        }}>
    <p className="text-long-mobile">
      <span className="text-long-bold" onClick={() => setToggled(!toggled)}>
        {" "}
        <i className={toggled ? "arrow down" : "arrow right"}></i>
        {toggled ? "Hide" : "  " + props.textToggleTitle}
      </span>
      {toggled ? (
        <span>
          <br />
          <br />
          {toggleParagraphs.map((p, i) => (
            <div
            style={{
              position: "relative",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              backgroundColor: "black",
              padding: "0px 0vw 6px 0vw",

          }}>
              <span className="text-long-toggle-mobile">
                {processToggleParagraph(toggleParagraphs[i])}
              </span>
              <br />
              {/* <br /> */}
            </div>
          ))}
        </span>
      ) : null}
    </p>
 </div>)
  :
  (<div
        style={{
            position: "relative",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: "black",
            padding: "0px 25vw 4px 25vw",
        }}>
    <p className="text-long">
      <span className="text-long-bold" onClick={() => setToggled(!toggled)}>
        {" "}
        <i className={toggled ? "arrow down" : "arrow right"}></i>
        {toggled ? "Hide" : "  " + props.textToggleTitle}
      </span>
      {toggled ? (
        <span>
          <br />
          <br />
          {toggleParagraphs.map((p, i) => (
            <div
            style={{
              position: "relative",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              backgroundColor: "black",
              padding: "0px 0vw 6px 0vw",

          }}>
              <span className="text-long-toggle">
                {processToggleParagraph(toggleParagraphs[i])}
              </span>
              <br />
              {/* <br /> */}
            </div>
          ))}
        </span>
      ) : null}
    </p>
 </div>)
  );
}
